import {dataTestId} from '@hconnect/uikit/src/common'
import {HPButton} from '@hconnect/uikit/src/lib2'
import Markdown from 'markdown-to-jsx'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {useDialog} from '../../../shared/components/providers/DialogProvider'
import {useOptimizerConstraints} from '../../../shared/hooks/api'

import {OptimizerConstraintsDialogHeader} from './OptimizerConstraintsDialogHeader'

export const OptimizerConstraintsButton: React.FC = () => {
  const {t} = useTranslation()

  const {openDialog} = useDialog()

  const {data: optimizerConstraints} = useOptimizerConstraints()

  const handleShowConstraints = useCallback(() => {
    openDialog({
      header: <OptimizerConstraintsDialogHeader />,
      content: optimizerConstraints && <Markdown>{optimizerConstraints.combinedMarkdown}</Markdown>,
      dataTestId: 'optimizer_constraints_dialog'
    })
  }, [optimizerConstraints, openDialog])

  return (
    <HPButton
      backgroundMode="medium"
      onClick={handleShowConstraints}
      disabled={!optimizerConstraints}
      {...dataTestId('optimizer_constraints_button')}
    >
      {t('optimizer.constraints')}
    </HPButton>
  )
}
